import React from "react";
import QualityPolicyAndCertificates from "../../components/shared/QualityPolicyAndCertificates";
import Headline from "./Headline";
import HomeLink from "../../widgets/HomeLink";

const bannerPath = '/iceholidays-assets/images/about_gd_cover.png';
const breadcrumbs = [
  { title: <HomeLink/>},
  { title: 'About Us' }
] 

const AboutUsPage = () => (
  <div id="about-us-page" className="more-page">
    <Headline showSearch={false} bannerImage={bannerPath} breadcrumbs={breadcrumbs} title="About Us"/>

    <div className="more-page_body">
      <div className="more-page_content">
        <div id="article">
          <div id="article_image">
            <img src="/iceholidays-assets/images/about_gd.png"/>
          </div>
          <div id="article_text">
            <h1>"WHAT WE DO"</h1>
            <p>We are a full-service outbound travel experience curator, specializing in thoughtfully designed travel products and services under our flagship brand, Golden Destinations (GD). Operating mainly on a B2B model, we work exclusively with a licensed network of travel agents, enabling us to deliver ready-to-market travel experiences tailored to a wide range of customer needs.</p>
            <p>More than just a tour operator, we oversee every step of the travel journey—from itinerary planning, transportation, meals, and accommodation to destination-specific activities. Our goal is to ensure a seamless and memorable experience for all travellers.</p>
            <p>Backed by strong partnerships with international tour operators and a deep understanding of traveller expectations, we empower our agents with curated travel packages that are easy to market and sell. Our ability to consolidate multiple travellers into cohesive group tours allows our agents to overcome common volume challenges, offering efficient and cost-effective travel options without compromising on quality.</p>
            <p>At Golden Destinations, we bring together operational expertise, creative curation, and a strong agent network to make every travel experience smooth, enjoyable, and impactful.</p>
          </div>
        </div>

        <QualityPolicyAndCertificates
            showCertificates={false} 
            innovativeIcon={<img src="/iceholidays-assets/images/innovative_gd.png"/>}
            competitivenessIcon={<img src="/iceholidays-assets/images/competitiveness_gd.png"/>}
            ethicalIcon={<img src="/iceholidays-assets/images/ethical_gd.png"/>}/>
      </div>

    </div>
  </div>
);

export default AboutUsPage;